var render = function render(_c,_vm){return _c('div',{staticClass:"loader mx-auto",class:_vm.data.staticClass})
}
var staticRenderFns = []

export { render, staticRenderFns }